import Arrow from './Arrow';
import { C } from './theme';

const StatKPI = ({ label, value, drill, onClick }: { label: string; value: any; drill?: boolean; onClick?: () => void }) => (
    <div
        onClick={onClick}
        style={{
            background: C.card,
            border: `1px solid ${drill ? C.accent + "33" : C.cardBorder}`,
            borderRadius: 10,
            padding: "10px 10px",
            textAlign: "center",
            cursor: drill ? "pointer" : "default",
            position: "relative",
            boxShadow: C.shadow,
        }}
    >
        {drill && <Arrow />}
        <div style={{ fontSize: 8, color: C.t3, textTransform: "uppercase", letterSpacing: 0.3 }}>{label}</div>
        <div style={{ fontSize: 18, fontWeight: 700, color: C.t1, marginTop: 3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{value}</div>
    </div>
);

export default StatKPI;

